import useWalletContext from './useWalletContext';

const useIsMyAddress = (address) => {
  const { address: myAddress } = useWalletContext();
  return address === myAddress;
};

export default useIsMyAddress;
